import React, { useState, Component, Fragment } from "react"
import { accessRole } from "../../../../../../helpers/access_role"
import { config } from "../../../../../../helpers/config_global"
import { Redirect } from "react-router-dom"

import { Label, Tooltip } from "reactstrap"
import MKIDatatable from '../../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../../services/adapters/kepegawaian/cutiService"

import DataTableBloc from '../Blocs/DataTableBloc'
import apiResponse from '../../../../../../services/apiResponse'

const reformatDate = (date, withDay = false) => {
    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];
    const days = [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jum'at",
        "Sabtu"
    ]

    const d = new Date(date);

    let dt = d.getDate()
    if (dt < 10)
        dt = '0'+dt

    let day = ''
    if (withDay) {
        day = days[d.getDay()] + ", "
    }

    if (date) {
        return day + dt + " " + months[d.getMonth()] + " " + d.getFullYear();
    }

    return '-'
};


class TableActiveComponent extends Component {
    dataTableBloc = new DataTableBloc();

    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'))
    peg_detail = !accessRole('approve') ? (this.userdata != null ? this.userdata : "")
    : (this.employeeSeleted != null ? this.employeeSeleted : "")

    source
    historyTable = 'historyHomeKepegawaianCutiBawahanTableActive'
    defaultOrder = 'paid_leave_id'
    defaultSize = 10
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            tooltip: false,
            detailUuid: null,
            updateUuid: null,
            saldoUuid: null,
            inactiveUuid: null,
            revokeUuid: null,
            approveUuid: null,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
    }
    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        let additionalFilter = this.props.additionalFilter;

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1,
            date_start: this.props.filter?.dateStart,
            date_end: this.props.filter?.dateEnd,
            approval_status: this.props.filter?.status,
            work_unit_uuid: this.peg_detail.employee_current_work_unit_uuid,
            employee_uuid: this.peg_detail.employee_uuid,
            // Halaman ini udah punya selector "Jabatan" eksplisit (definitif/Plt) buat nentuin
            // scope bawahan, jadi auto-merge tugas tambahan aktif punya peg_detail (legacy
            // behavior backend) dimatiin biar gak polusi default view sama bawahan Plt-nya.
            include_additional_task: '0',
            ...additionalFilter
        }
        await this.dataTableBloc.fetchRowTable(query, this.source.token)
        console.log(this.source.token, 'source')
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.inactiveData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }

    inactiveData = async () => {
        await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid })
    }

    componentDidMount() {
        this.setTokenAPI()

        this.dataTableBloc.rowtableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })

        this.dataTableBloc.inactiveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        loadingTable: true
                    }, function () {
                        this.setTokenAPI()
                        this.props.handleInactiveSuccess()
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.filter !== this.props.filter) {
            this.loadData()
        }
    }

    componentWillUnmount() {
        this.dataTableBloc.rowtableChannel?.unsubscribe()
        this.dataTableBloc.inactiveChannel?.unsubscribe()
    }

    columns = [
        {
            key: "paid_leave_employee_full_name",
            text: "Pegawai",
        },
        {
            key: "paid_leave_type_full_name",
            text: "Jenis Cuti",
        },
        {
            key: "paid_leave_start_date",
            text: "Mulai Cuti",
            sortable: true,
            width: '20%',
            cell: record => {
                return reformatDate(record.paid_leave_start_date)
            }
        },
        {
            key: "paid_leave_end_date",
            text: "Selesai Cuti",
            sortable: true,
            width: '20%',
            cell: record => {
                return reformatDate(record.paid_leave_end_date)
            }
        },
        {
            key: "paid_leave_count",
            text: "Lama Hari Cuti",
            align: 'center',
        },
        {
            key: "paid_leave_approval_status",
            text: "Status",
            sortable: false,
            cell: record => {
                let color = 'info'
                if (record.paid_leave_approval_status === 1) {
                    color = 'success'
                } else if (record.paid_leave_approval_status === 2) {
                    color = 'warning'
                } else if (record.paid_leave_approval_status === 3) {
                    color = 'danger'
                } else if (record.paid_leave_approval_status === 4) {
                    color = 'danger'
                }
                return (
                    <Fragment>
                        <Label className={`badge rounded-pill bg-soft-${color} font-size-12`}>{record.paid_leave_approval_status_name}</Label>
                    </Fragment>
                )
            }
        },
        {
            key: "action",
            text: "Action",
            className: "action",
            width: 120,
            sortable: false,
            align: 'center',
            cell: record => {
                const thisId = record.paid_leave_id
                return (
                    <Fragment>
                        { record.paid_leave_approval_status === -1  &&
                            <Fragment>
                                {this.userdata?.is_atasan == 1 &&
                                    <span>
                                        <button
                                            className="btn btn-success btn-sm"
                                            id={"approve-"+thisId}
                                            onClick={() => {
                                                this.setState({
                                                    approveUuid: record.paid_leave_uuid
                                                })
                                            }}
                                            style={{
                                                marginRight: '2px',
                                                padding: '2px 5px'
                                            }}>
                                            <i className="uil-check"></i>
                                        </button>
                                    </span>
                                }
                            </Fragment>
                        }
                        { record.paid_leave_approval_status === 3 &&
                            <Fragment>
                                {accessRole('approve') &&
                                    <span>
                                        <button
                                            className="btn btn-danger btn-sm"
                                            id={"revoke-"+thisId}
                                            onClick={() => {
                                                this.setState({
                                                    revokeUuid: record.paid_leave_uuid
                                                })
                                            }}
                                            style={{
                                                marginRight: '2px',
                                                padding: '2px 5px'
                                            }}>
                                            <i className="uil-user-times"></i>
                                        </button>
                                    </span>
                                }
                            </Fragment>
                        }
                        <span>
                            <button
                                className="btn btn-primary btn-sm"
                                id={"detail-" + thisId}
                                onClick={() => {
                                    this.setState({
                                        detailUuid: record.paid_leave_uuid
                                    })

                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                    <i className="uil-file-search-alt"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["detail" + thisId] : !this.state["detail" + thisId]
                                    })
                                }}
                            >Lihat Detail</Tooltip>
                        </span>
                        <span>
                            <button
                                className="btn btn-info btn-sm"
                                id={"saldo-" + thisId}
                                onClick={() => {
                                    this.setState({
                                        saldoUuid: record.paid_leave_employee_uuid
                                    })

                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                    <i className="uil-calculator-alt"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["saldo" + thisId]} target={"saldo-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["saldo" + thisId] : !this.state["saldo" + thisId]
                                    })
                                }}
                            >Lihat Saldo Cuti</Tooltip>
                        </span>
                    </Fragment>
                );
            }
        }
    ]

    render() {
        return (
            <>
                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    minWidth={1000}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState({
                            loadingTable: true,
                            filter: filter
                        }, function () {
                            this.setTokenAPI()
                        });
                    }}
                    loading={this.state.loadingTable}
                />
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menghapus data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil dihapus"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal dihapus"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.approveUuid !== null ?
                    <Redirect to={`/izinpegawai/cuti.html?approve_bawahan&uuid=${this.state.approveUuid}`}/>
                : null }
                { this.state.detailUuid !== null ?
                    <Redirect to={`/izinpegawai/cuti.html?detail&uuid=${this.state.detailUuid}&ref=list_bawahan`}/>
                : null }
                { this.state.revokeUuid !== null ?
                    <Redirect to={`/izinpegawai/cuti.html?revoke&uuid=${this.state.revokeUuid}`}/>
                : null }
                { this.state.saldoUuid !== null ?
                    <Redirect to={`/izinpegawai/cuti.html?saldo&uuid=${this.state.saldoUuid}`}/>
                : null }
            </>
        )
    }

}

export default TableActiveComponent
